import { NextPage } from 'next';
import React from 'react';
import { useDispatch } from 'react-redux';

import PageHandler from '@jpp/shared/PageHandler';
import Experience from '@jpp/templates/Experience';
import { IReduxState } from 'common/redux/createStore';
import { IPageStoreState } from 'common/redux/page/reducer';
import { getPageFromState } from 'common/redux/page/selectors';
import { clearPage, getPage } from 'common/redux/rootActions';
import { EPageType } from 'common/typings/enums';
import { TReduxError, TTemplateInitialProps } from 'common/typings/types';
import { shouldPageError } from 'common/utils/shared/page';

interface IExperiencePageProps {
  error?: TReduxError;
  slug?: string;
  page: IPageStoreState;
}

const ExperiencePage: NextPage<IExperiencePageProps> = (props) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (props.error) {
      dispatch(getPage(EPageType.Experience));
    }

    return () => {
      dispatch(clearPage());
    };
  }, []);

  return (
    <PageHandler
      {...props}
      pageType={EPageType.Experience}
      template={Experience}
    />
  );
};

ExperiencePage.getInitialProps = async ({
  res,
  store,
}: TTemplateInitialProps): Promise<IExperiencePageProps> => {
  const dispatch = store.dispatch;
  await dispatch(getPage(EPageType.Experience) as any);
  const state: IReduxState = store.getState();
  const page: IPageStoreState = getPageFromState(state);

  await shouldPageError(page, res, dispatch);

  return {
    slug: EPageType.Experience,
    page,
  };
};

export default ExperiencePage;
